import app from '../../forum/app';
import DefaultResolver from '../../common/resolvers/DefaultResolver';
export default class UserPageResolver extends DefaultResolver {
  canonicalizeUserSlug(slug) {
    if (!slug) return;
    return slug.split('-')[0];
  }
  makeKey() {
    const params = {
      ...m.route.param()
    };
    params.username = this.canonicalizeUserSlug(params.username);
    return this.routeName + JSON.stringify(params);
  }
  render(vnode) {
    const currentSlug = m.route.param('username');
    const id = this.canonicalizeUserSlug(currentSlug);
    if (id) {
      const user = app.store.getById('users', id);
      if (user && user.slug() && currentSlug !== user.slug()) {
        window.history.replaceState(null, '', app.route(this.routeName, {
          username: user.slug()
        }));
      }
    }
    return super.render(vnode);
  }
}
flarum.reg.add('core', 'forum/resolvers/UserPageResolver', UserPageResolver);